import React from 'react'
import AlertModal from './AlertModal';
import TextDatenschutz from '../Shared/TextDatenschutz';
import { useTranslation } from 'react-i18next';

const ShowDatenschutzModal = (props) => {

  const { t } = useTranslation();

  return (
    <AlertModal modalTitle={ t( 'modal.privacy.title' ) }>
      <TextDatenschutz />
    </AlertModal>
  )
}

export default ShowDatenschutzModal



// WEBPACK FOOTER //
// ./src/components/Modals/ShowDatenschutzModal.js